import { useState, useEffect } from 'react';
import '../styles/global.css';

const SECCIONES = [
  { key: 'dashboard', label: 'Dashboard', roles: ['admin', 'gerente', 'usuario', 'celular', 'rrhh'] },
  { key: 'sucursales', label: 'Sucursales', roles: ['admin'] },
  { key: 'areas', label: 'Áreas', roles: ['admin'] },
  { key: 'usuarios', label: 'Usuarios', roles: ['admin', 'usuario', 'gerente', 'celular', 'rrhh'] },
  { key: 'celulares', label: 'Celulares', roles: ['admin', 'celular'] },
  { key: 'equipos', label: 'Equipos', roles: ['admin', 'gerente', 'usuario', 'celular'] },
  { key: 'asignaciones', label: 'Asignaciones', roles: ['admin', 'gerente', 'usuario', 'celular', 'rrhh'] },
  { key: 'tarjetas', label: 'Tarjetas', roles: ['admin', 'gerente', 'usuario', 'celular'] },
];

const API_URL = process.env.REACT_APP_API_URL;

function Navbar({ currentUser, logout, pantalla, setPantalla, token }) {
  const rol = currentUser?.rol;
  const seccionesVisibles = SECCIONES.filter(s => s.roles.includes(rol));

  const [tieneFirma, setTieneFirma] = useState(true); // asume que sí hasta verificar
  const [subiendo, setSubiendo] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await fetch(`${API_URL}/firmas/mia`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        const data = await res.json();

        setTieneFirma(!!data.tiene_firma);

      } catch (error) {
        console.error('Error:', error);
      }
    };

    cargar();
  }, []);
  const handleSubirFirma = async (e) => {
    const archivo = e.target.files[0];
    if (!archivo) return;
    setSubiendo(true);
    const formData = new FormData();
    formData.append('firma', archivo);
    try {
      await fetch(`${API_URL}/firmas`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData
      });
      setTieneFirma(true); // oculta el botón
    } catch {
      alert('No se pudo subir la firma');
    } finally {
      setSubiendo(false);
      e.target.value = '';
    }
  };

  return (
    <nav className='navbar'>
      <div className='navbar-top'>
        <img src="/logo.png" alt="Logo" className='navbar-logo' />
        <span className='navbar-fecha'>
          {new Date().toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </span>
        <button
          onClick={() => setMenuAbierto(m => !m)}
          className="navbar-hamburger"
          aria-label="Toggle menu"
        >
          ☰
        </button>
      </div>
      {/* Clase 'open' condicional según menuAbierto */}
      <div className={`navbar-secciones ${menuAbierto ? 'open' : ''}`}>
        <div className="navbar-links">
          {seccionesVisibles.map(s => (
            <button
              key={s.key}
              className={`tab ${pantalla === s.key ? 'active' : ''}`}
              onClick={() => {
                setPantalla(s.key);
                setMenuAbierto(false); // Cierra el menú al seleccionar pestaña
              }}
            >
              {s.label}
            </button>
          ))}
        </div>

        <div className="navbar-actions">
          {!tieneFirma && rol === 'admin' && (
            <label className="btn-firma">
              {subiendo ? 'Subiendo...' : '✍️ Subir firma'}
              <input type="file" accept="image/*" style={{ display: 'none' }}
                onChange={handleSubirFirma} disabled={subiendo} />
            </label>
          )}

          <span className="navbar-role"><b>{rol}</b></span>
          <button className="btn-delete" onClick={logout}>Cerrar sesión</button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;